import React, { useState } from 'react';
import { 
  FaMapMarkerAlt, 
  FaPhone, 
  FaEnvelope, 
  FaClock,
  FaWhatsapp,
  FaTelegram,
  FaFacebook,
  FaInstagram,
  FaTwitter,
  FaLinkedin,
  FaPaperPlane,
  FaUser,
  FaComment,
  FaHeadset,
  FaTruck,
  FaShieldAlt,
  FaUndo,
  FaStar,
  FaFire,
  FaArrowRight
} from 'react-icons/fa';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const [formSubmitted, setFormSubmitted] = useState(false);
  const [formErrors, setFormErrors] = useState({});

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
    if (formErrors[e.target.name]) {
      setFormErrors({
        ...formErrors,
        [e.target.name]: null
      });
    }
  };

  const validateForm = () => {
    const errors = {};
    if (!formData.name.trim()) errors.name = 'Name is required';
    if (!formData.email.trim()) errors.email = 'Email is required';
    else if (!/\S+@\S+\.\S+/.test(formData.email)) errors.email = 'Email is invalid';
    if (!formData.message.trim()) errors.message = 'Message is required';
    return errors;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const errors = validateForm();
    if (Object.keys(errors).length === 0) {
      setFormSubmitted(true);
      setTimeout(() => {
        setFormSubmitted(false);
        setFormData({
          name: '',
          email: '',
          phone: '',
          subject: '',
          message: ''
        });
      }, 3000);
    } else {
      setFormErrors(errors);
    }
  };

  const contactInfo = [
    {
      icon: <FaPhone className="text-2xl" />,
      title: 'Call Us',
      info: '+91 9709799555',
      sub: '24/7 Customer Support',
      color: 'from-orange-500 to-orange-600',
      bg: 'bg-orange-50',
      textColor: 'text-orange-600',
      action: 'tel:+9118001234567'
    },
    {
      icon: <FaWhatsapp className="text-2xl" />,
      title: 'WhatsApp',
      info: '+91 9709799555',
      sub: 'Quick Response within 1hr',
      color: 'from-orange-500 to-orange-600',
      bg: 'bg-orange-50',
      textColor: 'text-orange-600',
      action: 'https://wa.me/9709799555'
    },
    {
      icon: <FaEnvelope className="text-2xl" />,
      title: 'Email Us',
      info: 'info@brframes.com',
      sub: 'info@brframes.com',
      color: 'from-orange-500 to-orange-600',
      bg: 'bg-orange-50',
      textColor: 'text-orange-600',
      action: 'mailto:info@brframes.com'
    },
    {
      icon: <FaMapMarkerAlt className="text-2xl" />,
      title: 'Visit Office',
      info: ' BRframes, opposite west gate of police station, Bhabua Bihar 821101',
      sub: 'Mon-Sat, 10am - 7pm',
      color: 'from-orange-500 to-orange-600',
      bg: 'bg-orange-50',
      textColor: 'text-orange-600',
      action: '#'
    }
  ];

  const storeLocations = [
    {
      city: 'Mumbai',
      address: 'Unit No. 201, 2nd Floor, Phoenix Marketcity, Kurla West, Mumbai - 400070',
      phone: '+91 9709799555',
      hours: '10:00 AM - 9:00 PM',
      landmark: 'Near Phoenix Mall'
    },
    {
      city: 'Delhi',
      address: 'Shop No. 45, Select Citywalk Mall, Saket District Centre, New Delhi - 110017',
      phone: '+91 9709799555',
      hours: '10:00 AM - 9:00 PM',
      landmark: 'Near PVR Cinemas'
    },
    {
      city: 'Bangalore',
      address: 'Ground Floor, Forum Mall, Koramangala, Bengaluru - 560095',
      phone: '+91 80 3456 7890',
      hours: '10:00 AM - 9:00 PM',
      landmark: 'Near Central'
    }
  ];

  const faqs = [
    {
      question: 'How can I track my order?',
      answer: 'You can track your order by logging into your account or using the tracking link sent to your email.'
    },
    {
      question: 'What is your return policy?',
      answer: 'We offer 30-day hassle-free returns on all frames. Contact our support team to initiate return.'
    },
    {
      question: 'Do you offer international shipping?',
      answer: 'Yes, we ship to select countries. Shipping charges and delivery times vary by location.'
    },
    {
      question: 'How do I find my frame size?',
      answer: 'Check our Frame Size Guide or visit any BRframes store for expert fitting assistance.'
    }
  ];

  return (
    <div className="bg-gradient-to-b from-white via-orange-50 to-white">
      <div className="bg-gradient-to-r from-orange-500 to-orange-600 text-white py-16 relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,white,transparent)]"></div>
        </div>
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative">
          <div className="inline-flex items-center gap-2 bg-black/20 backdrop-blur-sm px-4 py-2 rounded-full text-sm font-semibold mb-4 border border-white/20">
            <FaStar className="text-yellow-300" />
            <span>GET IN TOUCH</span>
            <FaStar className="text-yellow-300" />
          </div>
          <h1 className="text-4xl md:text-5xl font-bold mb-4">Contact Us</h1>
          <p className="text-xl text-orange-100 max-w-2xl mx-auto">
            We're here to help! Reach out to us for any questions, concerns, or feedback.
          </p>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 -mt-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
          {contactInfo.map((item, index) => (
            <a
              key={index}
              href={item.action}
              className={`group ${item.bg} rounded-xl shadow-lg hover:shadow-2xl transition-all duration-500 transform hover:-translate-y-2 overflow-hidden border border-orange-200 hover:border-orange-500`}
            >
              <div className="p-6">
                <div className={`w-14 h-14 rounded-xl bg-gradient-to-r ${item.color} text-white flex items-center justify-center mb-4 group-hover:scale-110 group-hover:rotate-6 transition-all duration-300 shadow-md`}>
                  {item.icon}
                </div>
                <h3 className="text-lg font-semibold text-gray-800 mb-1 group-hover:text-orange-500 transition-colors">{item.title}</h3>
                <p className="text-base font-bold text-gray-900 mb-1">{item.info}</p>
                <p className="text-sm text-gray-500">{item.sub}</p>
              </div>
              <div className="absolute bottom-0 left-5 right-5 h-[2px] bg-gradient-to-r from-transparent via-orange-500 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500"></div>
            </a>
          ))}
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid lg:grid-cols-2 gap-12">
          <div className="bg-white rounded-2xl shadow-xl p-8 border border-gray-100">
            <h2 className="text-2xl font-bold text-gray-800 mb-2">Send us a Message</h2>
            <p className="text-gray-500 mb-6">We'll get back to you within 24 hours</p>
            
            {formSubmitted ? (
              <div className="bg-orange-50 border border-orange-200 rounded-lg p-8 text-center">
                <div className="w-20 h-20 bg-orange-100 rounded-full flex items-center justify-center mx-auto mb-4">
                  <FaPaperPlane className="text-orange-500 text-3xl" />
                </div>
                <h3 className="text-2xl font-bold text-orange-600 mb-2">Message Sent!</h3>
                <p className="text-gray-600">Thank you for contacting us. We'll reply soon.</p>
              </div>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Your Name *</label>
                  <div className="relative">
                    <input
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      className={`w-full px-4 py-3 pl-11 border ${formErrors.name ? 'border-red-500' : 'border-gray-300'} rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 transition-all`}
                      placeholder="John Doe"
                    />
                    <FaUser className={`absolute left-4 top-3.5 ${formErrors.name ? 'text-red-500' : 'text-gray-400'}`} />
                  </div>
                  {formErrors.name && <p className="text-red-500 text-xs mt-1">{formErrors.name}</p>}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Email Address *</label>
                  <div className="relative">
                    <input
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      className={`w-full px-4 py-3 pl-11 border ${formErrors.email ? 'border-red-500' : 'border-gray-300'} rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 transition-all`}
                      placeholder="john@example.com"
                    />
                    <FaEnvelope className={`absolute left-4 top-3.5 ${formErrors.email ? 'text-red-500' : 'text-gray-400'}`} />
                  </div>
                  {formErrors.email && <p className="text-red-500 text-xs mt-1">{formErrors.email}</p>}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Phone Number</label>
                  <div className="relative">
                    <input
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      className="w-full px-4 py-3 pl-11 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 transition-all"
                      placeholder="+91 9709799555"
                    />
                    <FaPhone className="absolute left-4 top-3.5 text-gray-400" />
                  </div>
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Subject</label>
                  <input
                    type="text"
                    name="subject"
                    value={formData.subject}
                    onChange={handleChange}
                    className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 transition-all"
                    placeholder="How can we help?"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">Message *</label>
                  <div className="relative">
                    <textarea
                      name="message"
                      value={formData.message}
                      onChange={handleChange}
                      rows="4"
                      className={`w-full px-4 py-3 pl-11 border ${formErrors.message ? 'border-red-500' : 'border-gray-300'} rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-500 transition-all`}
                      placeholder="Tell us more about your query..."
                    ></textarea>
                    <FaComment className={`absolute left-4 top-3.5 ${formErrors.message ? 'text-red-500' : 'text-gray-400'}`} />
                  </div>
                  {formErrors.message && <p className="text-red-500 text-xs mt-1">{formErrors.message}</p>}
                </div>

                <button
                  type="submit"
                  className="w-full bg-gradient-to-r from-orange-500 to-orange-600 text-white py-3 rounded-lg font-semibold hover:from-orange-600 hover:to-orange-700 transition-all duration-300 transform hover:scale-105 shadow-lg flex items-center justify-center gap-2 group"
                >
                  <FaPaperPlane className="group-hover:translate-x-1 transition-transform" />
                  Send Message
                </button>
              </form>
            )}
          </div>

          <div className="space-y-6">
            <div className="bg-gradient-to-r from-orange-500 to-orange-600 rounded-2xl p-8 text-white relative overflow-hidden">
              <div className="absolute inset-0 opacity-10">
                <div className="absolute inset-0 bg-[radial-gradient(circle_at_30%_50%,white,transparent)]"></div>
              </div>
              <div className="relative">
                <FaHeadset className="text-4xl mb-4" />
                <h3 className="text-2xl font-bold mb-2">Live Chat Support</h3>
                <p className="text-orange-100 mb-4">Chat with our experts for instant help</p>
                <button className="bg-black text-white px-6 py-2 rounded-full font-semibold hover:bg-gray-800 transition-all duration-300 transform hover:scale-105">
                  Start Live Chat
                </button>
              </div>
            </div>
            <div className="bg-white rounded-2xl shadow-xl p-6 border border-gray-100">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">Quick Help</h3>
              <div className="space-y-3">
                <a href="#" className="flex items-center gap-3 text-gray-600 hover:text-orange-500 transition-colors group">
                  <FaTruck className="text-orange-500 group-hover:scale-110 transition-transform" />
                  <span>Track Your Order</span>
                </a>
                <a href="#" className="flex items-center gap-3 text-gray-600 hover:text-orange-500 transition-colors group">
                  <FaUndo className="text-orange-500 group-hover:scale-110 transition-transform" />
                  <span>Returns & Exchange</span>
                </a>
                <a href="#" className="flex items-center gap-3 text-gray-600 hover:text-orange-500 transition-colors group">
                  <FaShieldAlt className="text-orange-500 group-hover:scale-110 transition-transform" />
                  <span>Warranty Information</span>
                </a>
                <a href="#" className="flex items-center gap-3 text-gray-600 hover:text-orange-500 transition-colors group">
                  <FaStar className="text-orange-500 group-hover:scale-110 transition-transform" />
                  <span>Write a Review</span>
                </a>
              </div>
            </div>
            <div className="bg-white rounded-2xl shadow-xl p-6 border border-gray-100">
              <h3 className="text-lg font-semibold text-gray-800 mb-4">Connect With Us</h3>
              <div className="flex gap-3">
                <a href="#" className="w-10 h-10 bg-orange-100 text-orange-600 rounded-full flex items-center justify-center hover:bg-orange-500 hover:text-white transition-all duration-300 transform hover:scale-110">
                  <FaFacebook />
                </a>
                <a href="#" className="w-10 h-10 bg-orange-100 text-orange-600 rounded-full flex items-center justify-center hover:bg-orange-500 hover:text-white transition-all duration-300 transform hover:scale-110">
                  <FaInstagram />
                </a>
                <a href="#" className="w-10 h-10 bg-orange-100 text-orange-600 rounded-full flex items-center justify-center hover:bg-orange-500 hover:text-white transition-all duration-300 transform hover:scale-110">
                  <FaTwitter />
                </a>
                <a href="#" className="w-10 h-10 bg-orange-100 text-orange-600 rounded-full flex items-center justify-center hover:bg-orange-500 hover:text-white transition-all duration-300 transform hover:scale-110">
                  <FaLinkedin />
                </a>
                <a href="#" className="w-10 h-10 bg-orange-100 text-orange-600 rounded-full flex items-center justify-center hover:bg-orange-500 hover:text-white transition-all duration-300 transform hover:scale-110">
                  <FaWhatsapp />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="text-center mb-12">
          <div className="inline-flex items-center gap-2 bg-orange-500 text-white px-4 py-2 rounded-full text-sm font-semibold mb-4">
            <FaStar className="text-white" />
            <span>FAQ</span>
            <FaStar className="text-white" />
          </div>
          <h2 className="text-3xl font-bold text-gray-800 mb-3">Frequently Asked Questions</h2>
          <p className="text-gray-500 max-w-2xl mx-auto">Quick answers to common questions</p>
        </div>

        <div className="grid md:grid-cols-2 gap-6">
          {faqs.map((faq, index) => (
            <div key={index} className="bg-white rounded-xl p-6 shadow-md hover:shadow-xl transition-all duration-300 border border-gray-100 hover:border-orange-500 transform hover:-translate-y-1">
              <h3 className="text-lg font-semibold text-gray-800 mb-2">{faq.question}</h3>
              <p className="text-gray-500 text-sm">{faq.answer}</p>
            </div>
          ))}
        </div>

        <div className="text-center mt-8">
          <a href="#" className="inline-flex items-center gap-2 text-orange-500 hover:text-orange-600 font-semibold transition-colors group">
            <span>View all FAQs</span>
            <FaArrowRight className="text-xs group-hover:translate-x-1 transition-transform" />
          </a>
        </div>
      </div>

      <div className="flex justify-center items-center gap-3 pb-8">
        <div className="w-2 h-2 bg-orange-300 rounded-full animate-pulse"></div>
        <div className="w-2 h-2 bg-orange-400 rounded-full animate-pulse" style={{ animationDelay: '0.2s' }}></div>
        <div className="w-2 h-2 bg-orange-500 rounded-full animate-pulse" style={{ animationDelay: '0.4s' }}></div>
        <div className="w-2 h-2 bg-orange-400 rounded-full animate-pulse" style={{ animationDelay: '0.6s' }}></div>
        <div className="w-2 h-2 bg-orange-300 rounded-full animate-pulse" style={{ animationDelay: '0.8s' }}></div>
      </div>

      <style jsx>{`
        @keyframes spin-slow {
          from { transform: rotate(0deg); }
          to { transform: rotate(360deg); }
        }
        .animate-spin-slow {
          animation: spin-slow 3s linear infinite;
        }
      `}</style>
    </div>
  );
};

export default ContactPage;